/* eslint-disable import/prefer-default-export */
export const MAX_INDEX = 50
